module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_8023.8400f81c.png";